import { render, staticRenderFns } from "./facilityDc.vue?vue&type=template&id=2e4b6ad0&scoped=true"
import script from "./facilityDc.vue?vue&type=script&lang=js"
export * from "./facilityDc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b6ad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e4b6ad0')) {
      api.createRecord('2e4b6ad0', component.options)
    } else {
      api.reload('2e4b6ad0', component.options)
    }
    module.hot.accept("./facilityDc.vue?vue&type=template&id=2e4b6ad0&scoped=true", function () {
      api.rerender('2e4b6ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/ReceiveVolume/facilityDc.vue"
export default component.exports